import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import { CollectionName } from "../../atoms/collection-name";
import LoadingIcon from "../../../../assets/images/loader.svg";
import "./video-playlist.m.css";
import assetify from "@quintype/framework/assetify";

const VideoPlaylist = ({ collection, youtubePlaylistId = "" }) => {
  const [playListItems, setPlayListItems] = useState([]);
  const [nowPlayingURL, setNowPlayingURL] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlaylist = async () => {
      setLoading(true);

      try {
        const { data } = await axios.get(
          `https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=100&playlistId=${(collection &&
            collection["associated-metadata"].playlistId) ||
            youtubePlaylistId}&key=AIzaSyDhn4laWphWRpS9mIEDmX2BnCzZP8SNdyk`
        );

        setPlayListItems(data.items);
        setNowPlayingURL(data.items[0].snippet.resourceId.videoId);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    fetchPlaylist();
  }, []);

  if (loading) {
    return (
      <div className="full-width-with-padding" styleName="wrapper">
        <div className="container">
          <div styleName="loading-wrapper">
            <img src={assetify(LoadingIcon)} alt="loading" />
          </div>
        </div>
      </div>
    );
  }

  return collection ? (
    <div className="full-width-with-padding" styleName="wrapper">
      <div className="container">
        <CollectionName collection={collection} color="#fff" />
        {playListItems.length && (
          <div styleName="layout">
            <div styleName="now-playing">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${nowPlayingURL}?rel=0&amp;`}
                allow="autoplay"
                styleName="iframeYT"
                allowFullScreen
              />
            </div>
            <div styleName="videos-div">
              {playListItems
                .slice(1, playListItems.length)
                .map(({ snippet, etag }) => (
                  <div
                    key={etag}
                    styleName="video-thumbnail"
                    onClick={() => setNowPlayingURL(snippet.resourceId.videoId)}
                  >
                    <img
                      src={snippet.thumbnails.medium.url}
                      alt={snippet.title}
                    />
                    <div styleName="video-title">
                      <p>{snippet.title}</p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div styleName="story-layout-wrapper">
      <div styleName="story-layout-grid">
        <div styleName="now-playing" style={{ height: "300px" }}>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${nowPlayingURL}?rel=0&amp;`}
            allow="autoplay"
            styleName="iframeYT"
            allowFullScreen
          />
        </div>
        <div styleName="videos-div scrollbar-gray">
          {playListItems
            .slice(1, playListItems.length)
            .map(({ snippet, etag }) => (
              <div
                key={etag}
                styleName="video-thumbnail"
                onClick={() => setNowPlayingURL(snippet.resourceId.videoId)}
              >
                <img src={snippet.thumbnails.medium.url} alt={snippet.title} />
                <div styleName="video-title">
                  <p>{snippet.title}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

VideoPlaylist.propTypes = {
  collection: PropTypes.object,
  youtubePlaylistId: PropTypes.string
};

export { VideoPlaylist };
